import { ShieldX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth-context';
import { useTenant } from '@/lib/tenant-context';

export function AcessoNegadoPage() {
  const navigate = useNavigate();
  const { user, role, signOut } = useAuth();
  const { tenant } = useTenant();

  async function handleSair() {
    await signOut();
    navigate('/login');
  }

  return (
    <div className="bg-muted/30 flex min-h-screen items-center justify-center p-6">
      <div className="bg-card w-full max-w-md space-y-6 rounded-xl border p-8 text-center shadow">
        <div className="bg-destructive/10 mx-auto flex h-12 w-12 items-center justify-center rounded-full">
          <ShieldX className="text-destructive h-6 w-6" />
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold">Acesso negado</h1>
          <p className="text-muted-foreground text-sm">
            Sua conta nao tem permissao para acessar o painel administrativo
            {tenant?.nom_tenant ? ` do ${tenant.nom_tenant}` : ''}. Entre com uma conta de
            administrador ou peca acesso ao DPO do seu tenant.
          </p>
        </div>
        <div className="bg-muted/40 rounded-md border p-3 text-left text-xs">
          <div>
            <span className="text-muted-foreground">Conta: </span>
            <span className="font-medium">{user?.email ?? '—'}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Papel: </span>
            <span className="font-medium">{role ?? 'sem papel'}</span>
          </div>
        </div>
        <Button onClick={handleSair} className="w-full">
          Sair e voltar para o login
        </Button>
      </div>
    </div>
  );
}
